import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Pro3SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M10.328 3.56a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM9.177 4.902a2.75 2.75 0 1 1 1.06 1.06L5.48 10.721a2.75 2.75 0 1 1-1.06-1.06L9.176 4.9Zm-7.349 7.16a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm1.25-7.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM.328 3.56a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0Zm10 8.5a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm1.25 2.75a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pro3SVG;
